import React, { FC, useMemo } from 'react';
import { PropertiesPanel } from '../../../../../../widgets/propertiesPanel';
import { CameraLocationHelpers, CameraLocationNode, useCameraLocationPropertiesCreator } from '../cameraEditorConfig';
import InspectorShell from '../inspectorShell';

// L'involucro sta in `InspectorShell`, uno per tutti i generi: qui resta ciò che è solo di una
// camera salvata. Le proprietà le costruisce `cameraEditorConfig`, che è anche il posto dove sta
// scritto perché sono soltanto due.

export interface CameraLocationOverlayProps {
    name: string;
    camera: CameraLocationNode;
    /** Il nome si cambia anche dalla testata, come per ogni altro soggetto. */
    onRename: (name: string) => void;
    onChange: CameraLocationHelpers['onChange'];
}

const CameraLocationOverlayComponent: FC<CameraLocationOverlayProps> = ({ name, camera, onRename, onChange }) => {
    const createCameraLocationProperties = useCameraLocationPropertiesCreator();

    const helpers: CameraLocationHelpers = useMemo(() => ({ onChange }), [onChange]);
    const properties = useMemo(() => createCameraLocationProperties(camera, helpers), [createCameraLocationProperties, camera, helpers]);

    return (
        <InspectorShell kind='camera' name={name} onRename={onRename}>
            <PropertiesPanel properties={properties} />
        </InspectorShell>
    );
};

export default CameraLocationOverlayComponent;
